import React from 'react'
import { connect } from 'react-redux'
import AdministrationResetPassword from './AdministrationResetPassword'
import { reset, setEmailAddress } from './administrationResetPasswordContainerActions'
import PropTypes from 'prop-types'

class AdministrationResetPasswordContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    validationstate: PropTypes.object.isRequired,
    emailAddress: PropTypes.string.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    setEmailAddress: PropTypes.func.isRequired
  }

  render () {
    return (
      <AdministrationResetPassword
        validationstate={this.props.validationstate}
        emailAddress={this.props.emailAddress}
        submitting={this.props.submitting}
        submitted={this.props.submitted}
        reset={() => this.props.dispatch(this.props.reset(this.props.emailAddress))}
        emailAddressChange={(emailAddress) =>
          this.props.dispatch(this.props.setEmailAddress(emailAddress))
        }
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    submitting: state.administrationResetPasswordContainer.submitting,
    submitted: state.administrationResetPasswordContainer.submitted,
    validationstate: state.administrationResetPasswordContainer.isInvalid,
    emailAddress: state.administrationResetPasswordContainer.emailAddress
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reset,
    setEmailAddress,
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdministrationResetPasswordContainer)